import currencySymbol from './currencySymbol';

const formatWalletAmount = (amount, currencyCode) => {
  const value = Number(amount) || 0;
  const absolute = Math.abs(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `${value < 0 ? '-' : ''}${currencySymbol(currencyCode)}${absolute}`;
};

export default formatWalletAmount;
